import classNames from "classnames";
import React from "react";

import useScrollLock from "@repo/shopify/hooks/useScrollLock";

import { useLayoutStore } from "@store/layout";

interface IProps {
  onClick?: (e: React.MouseEvent) => void;
  className?: string; // 팁: ReactNode 대신 string이 올바른 타입입니다.
}

export default function Dim({ className, onClick }: IProps) {
  useScrollLock();

  const { closeAll } = useLayoutStore();

  return (
    <div
      className={classNames(
        "pc:z-50 fixed inset-0 bg-[#c4c4c4]/65 mix-blend-luminosity backdrop-grayscale dark:bg-[#c4c4c4]/30",
        className,
      )}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (onClick) {
          onClick(e);
          return;
        }

        closeAll();
      }}
      role="presentation"
    />
  );
}
